import {DayIdentifier, DeliveryWindowFormValues} from './types/deliveryWindow'

export const COUNTRY_CONFIGURATION_BUSINESS_LINES = [
  {label: 'RMC', slug: 'rmc', dataTestId: 'nav-link-country-configurations-rmc'},
  {label: 'AGG', slug: 'agg', dataTestId: 'nav-link-country-configurations-agg'},
  {label: 'CEM', slug: 'cem', dataTestId: 'nav-link-country-configurations-cem'}
] as const

export const CEM_SHIPPING_TYPES = [
  {labelKey: 'countryConfigurations.shippingTypes.baggedDeliver', value: 'bagged-deliver', dataTestId: 'nav-link-cem-bagged-deliver'},
  {labelKey: 'countryConfigurations.shippingTypes.baggedCollect', value: 'bagged-collect', dataTestId: 'nav-link-cem-bagged-collect'},
  {labelKey: 'countryConfigurations.shippingTypes.bulkDeliver', value: 'bulk-deliver', dataTestId: 'nav-link-cem-bulk-deliver'},
  {labelKey: 'countryConfigurations.shippingTypes.bulkCollect', value: 'bulk-collect', dataTestId: 'nav-link-cem-bulk-collect'}
] as const

/** Maps BL slug to its shipping types. BLs not listed here have no shipping type drilldown. */
export const BUSINESS_LINE_SHIPPING_TYPES: Record<string, typeof CEM_SHIPPING_TYPES> = {
  cem: CEM_SHIPPING_TYPES
}

/**
 * Unloading method codes in display order. The first 10 render in the left column and the
 * remaining 9 in the right column (matching Figma). Labels are resolved via i18n.
 */
export const UNLOADING_METHOD_CODES: {code: string; labelKey: string}[] = [
  {code: 'A', labelKey: 'countryConfigurations.unloadingMethods.codes.A'},
  {code: 'B', labelKey: 'countryConfigurations.unloadingMethods.codes.B'},
  {code: 'C', labelKey: 'countryConfigurations.unloadingMethods.codes.C'},
  {code: 'E', labelKey: 'countryConfigurations.unloadingMethods.codes.E'},
  {code: 'G', labelKey: 'countryConfigurations.unloadingMethods.codes.G'},
  {code: 'H', labelKey: 'countryConfigurations.unloadingMethods.codes.H'},
  {code: 'I', labelKey: 'countryConfigurations.unloadingMethods.codes.I'},
  {code: 'J', labelKey: 'countryConfigurations.unloadingMethods.codes.J'},
  {code: 'K', labelKey: 'countryConfigurations.unloadingMethods.codes.K'},
  {code: 'M', labelKey: 'countryConfigurations.unloadingMethods.codes.M'},
  {code: 'O', labelKey: 'countryConfigurations.unloadingMethods.codes.O'},
  {code: 'P', labelKey: 'countryConfigurations.unloadingMethods.codes.P'},
  {code: 'Q', labelKey: 'countryConfigurations.unloadingMethods.codes.Q'},
  {code: 'R', labelKey: 'countryConfigurations.unloadingMethods.codes.R'},
  {code: 'S', labelKey: 'countryConfigurations.unloadingMethods.codes.S'},
  {code: 'U', labelKey: 'countryConfigurations.unloadingMethods.codes.U'},
  {code: 'V', labelKey: 'countryConfigurations.unloadingMethods.codes.V'},
  {code: 'W', labelKey: 'countryConfigurations.unloadingMethods.codes.W'},
  {code: 'X', labelKey: 'countryConfigurations.unloadingMethods.codes.X'}
]

export const DAY_FULL_LABELS: Record<DayIdentifier, string> = {
  monday: 'countryConfigurations.days.mondayFull',
  tuesday: 'countryConfigurations.days.tuesdayFull',
  wednesday: 'countryConfigurations.days.wednesdayFull',
  thursday: 'countryConfigurations.days.thursdayFull',
  friday: 'countryConfigurations.days.fridayFull',
  saturday: 'countryConfigurations.days.saturdayFull',
  sunday: 'countryConfigurations.days.sundayFull',
  holiday: 'countryConfigurations.days.holidayFull',
}

export const EMPTY_HOURS: Record<string, {start: string; end: string}> = {
  onlineDelivery: {start: '', end: ''},
  defaultDelivery: {start: '', end: ''},
  slotManagement: {start: '', end: ''},
}

export type ConstraintField = keyof DeliveryWindowFormValues['deliveryConstraints']

export const CONSTRAINT_FIELDS: {key: ConstraintField; labelKey: string; tooltipKey: string}[] = [
  {
    key: 'minDeliveryWindow',
    labelKey: 'countryConfigurations.deliveryWindow.deliveryConstraints.minDeliveryWindow',
    tooltipKey: 'countryConfigurations.deliveryWindow.deliveryConstraints.minDeliveryWindowTooltip',
  },
  {
    key: 'minFixDeliveryWindow',
    labelKey: 'countryConfigurations.deliveryWindow.deliveryConstraints.minFixDeliveryWindow',
    tooltipKey: 'countryConfigurations.deliveryWindow.deliveryConstraints.minFixDeliveryWindowTooltip',
  },
  {
    key: 'stepInterval',
    labelKey: 'countryConfigurations.deliveryWindow.deliveryConstraints.stepInterval',
    tooltipKey: 'countryConfigurations.deliveryWindow.deliveryConstraints.stepIntervalTooltip',
  },
]